import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTransferService {

  private data: any;
  private pdfData:any;

  private docData:any;


  constructor() { }

  setData(data: any) {
    this.data = data;
  }

  getData() {
    return this.data;
  }

  setPdfData(data:any){
   this.pdfData = data;
  }

  getPdfData() {
    return this.pdfData;
  }

  setdocPdfData(data:any){
    this.docData = data;
   }
 
   getDocPdfData() {
     return this.docData;
   }
}
